import React, { useContext } from 'react';
import InitialRegistration from './InitialRegistration';
import StepsRegistration from './StepsRegistration';
import { Container, Row, Col } from "react-bootstrap";
import RegisterContext from './RegisterContext';

export default function RightSide(props) {
  const { process } = useContext(RegisterContext)
  return (
    <React.Fragment>
        {process === 'initial' && <InitialRegistration labels={props.labels} />}
        {process === 'steps' && <StepsRegistration labels={props.labels} />}
    </React.Fragment>
  )
}